import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import { Link } from 'react-router'

export function NotFoundPage() {
  return (
    <Box>
      <Typography variant="h1" gutterBottom>
        صفحه پیدا نشد
      </Typography>
      <Typography variant="body1" color="text.secondary" gutterBottom>
        در این نشانی چیزی وجود ندارد.
      </Typography>
      <Button component={Link} to="/" variant="contained" sx={{ mt: 2 }}>
        بازگشت به داشبورد
      </Button>
    </Box>
  )
}
